/* Zenduce checkout preservation fix - 2026-09-26
   Keep Shopify's native cart form submission intact so cart attributes,
   delivery selections and discount-function inputs are committed before checkout.
*/
(function () {
  'use strict';

  function restoreCheckoutButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;

    Array.prototype.forEach.call(scope.querySelectorAll('[data-zd-direct-checkout="true"], .zd-drawer-checkout'), function (element) {
      if (element.tagName === 'A' && element.getAttribute('data-zd-direct-checkout') === 'true') {
        var form = element.closest('form');
        if (!form) return;

        var button = document.createElement('button');
        Array.prototype.forEach.call(element.attributes, function (attribute) {
          if (['href','role','data-zd-direct-checkout'].indexOf(attribute.name) === -1) {
            button.setAttribute(attribute.name, attribute.value);
          }
        });
        button.setAttribute('type','submit');
        button.setAttribute('name','checkout');
        button.innerHTML = element.innerHTML;
        element.replaceWith(button);
      }
    });
  }

  function init() {
    restoreCheckoutButtons(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node.nodeType === 1) restoreCheckoutButtons(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', function () { restoreCheckoutButtons(document); });
  document.addEventListener('shopify:section:load', function (event) {
    restoreCheckoutButtons(event.target || document);
  });
})();

/* Zenduce mobile header search toggle - start */
(function () {
  'use strict';

  var MOBILE_MAX = 1024;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function getParts() {
    var header = document.querySelector('.zh-header');

    return {
      header: header,
      row: header && header.querySelector('.zh-mobile-search-row'),
      toggle: header && header.querySelector('.zh-main-row > .zh-wrap > .zh-search-wide')
    };
  }

  function setOpen(open) {
    var parts = getParts();
    if (!parts.row || !parts.toggle) return;

    parts.row.classList.toggle('is-open', !!open);
    parts.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    parts.toggle.setAttribute('aria-label', open ? 'Close search' : 'Open search');
  }

  function init() {
    var parts = getParts();
    if (!parts.toggle) return;

    parts.toggle.setAttribute('aria-expanded', parts.row && parts.row.classList.contains('is-open') ? 'true' : 'false');
    parts.toggle.setAttribute('aria-label', parts.row && parts.row.classList.contains('is-open') ? 'Close search' : 'Open search');
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var toggle = target.closest('.zh-header .zh-main-row > .zh-wrap > .zh-search-wide');
    if (!toggle || !isMobile()) return;

    var parts = getParts();
    if (!parts.row) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    setOpen(!parts.row.classList.contains('is-open'));
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setOpen(false);
  });

  window.addEventListener('resize', function () {
    if (!isMobile()) setOpen(false);
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', init, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();
/* Zenduce mobile header search toggle - end */

/* Zenduce collection second-image hover/swipe + dots - start */
(function () {
  'use strict';

  if (window.__zenduceCollectionSecondImageInit) return;
  window.__zenduceCollectionSecondImageInit = true;

  function isCollectionPage() {
    var path = window.location.pathname || '';
    var analyticsPageType = window.ShopifyAnalytics &&
      window.ShopifyAnalytics.meta &&
      window.ShopifyAnalytics.meta.page &&
      window.ShopifyAnalytics.meta.page.pageType;

    if (analyticsPageType === 'collection') return true;

    return /^\/collections\/[^\/]+\/?$/.test(path) ||
      !!document.querySelector('[id^="premium-collection-"], .shopify-section--main-collection, .pcp__grid');
  }

  if (!isCollectionPage()) return;

  var styleId = 'zenduce-collection-second-image-style';
  if (!document.getElementById(styleId)) {
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '.zenduce-second-image-ready{position:relative!important;overflow:hidden!important;}',
      '.zenduce-card-primary-image{transition:opacity .26s ease,visibility .26s ease,transform .45s ease!important;}',
      '.zenduce-card-second-image{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;display:block!important;object-fit:cover!important;opacity:0!important;visibility:hidden!important;z-index:1!important;transition:opacity .26s ease,visibility .26s ease,transform .45s ease!important;pointer-events:none!important;}',
      '.zenduce-card-dots{position:absolute!important;left:50%!important;bottom:12px!important;transform:translateX(-50%)!important;z-index:6!important;display:flex!important;align-items:center!important;justify-content:center!important;gap:7px!important;pointer-events:none!important;}',
      '.zenduce-card-dot{width:8px!important;height:8px!important;border-radius:999px!important;background:rgba(255,255,255,.68)!important;border:1px solid rgba(0,0,0,.08)!important;box-shadow:0 1px 4px rgba(0,0,0,.16)!important;opacity:.86!important;transition:background .2s ease,opacity .2s ease,transform .2s ease!important;}',
      '.zenduce-card-dot.is-active,.zenduce-card-has-second:not(.zenduce-mobile-second-active) .zenduce-card-dot:first-child{background:#fff!important;opacity:1!important;transform:scale(1.14)!important;}',
      '.zenduce-card-has-second.zenduce-mobile-second-active .zenduce-card-dot:first-child{background:rgba(255,255,255,.68)!important;opacity:.86!important;transform:scale(1)!important;}',
      '.zenduce-card-has-second.zenduce-mobile-second-active .zenduce-card-dot:nth-child(2){background:#fff!important;opacity:1!important;transform:scale(1.14)!important;}',
      '@media screen and (hover:hover) and (pointer:fine){.zenduce-card-has-second:hover .zenduce-card-primary-image{opacity:0!important;visibility:hidden!important;}.zenduce-card-has-second:hover .zenduce-card-second-image{opacity:1!important;visibility:visible!important;}.zenduce-card-has-second:hover .zenduce-card-dot:first-child{background:rgba(255,255,255,.68)!important;opacity:.86!important;transform:scale(1)!important;}.zenduce-card-has-second:hover .zenduce-card-dot:nth-child(2){background:#fff!important;opacity:1!important;transform:scale(1.14)!important;}}',
      '@media screen and (max-width:749px){.zenduce-card-has-second .pcp__product-image,.zenduce-card-has-second .product-card__figure a{touch-action:pan-y!important;}.zenduce-card-has-second.zenduce-mobile-second-active .zenduce-card-primary-image{opacity:0!important;visibility:hidden!important;}.zenduce-card-has-second.zenduce-mobile-second-active .zenduce-card-second-image{opacity:1!important;visibility:visible!important;}.zenduce-card-dots{bottom:12px!important}.zenduce-card-dot{width:8px!important;height:8px!important;}}'
    ].join('\n');
    document.head.appendChild(style);
  }

  var productJsonCache = new Map();
  var productLinksSelector = [
    '.pcp__product-card .pcp__product-image[href*="/products/"]',
    'product-card .product-card__figure a[href*="/products/"]'
  ].join(',');

  function getProductHandle(link) {
    try {
      var url = new URL(link.href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^\/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  }

  function getCard(link) {
    return link.closest('.pcp__product-card') || link.closest('product-card') || link;
  }

  function getPrimaryImage(link) {
    return link.querySelector('img:not(.zenduce-card-second-image)');
  }

  function getSecondImageSrc(handle) {
    if (!handle) return Promise.resolve('');

    if (productJsonCache.has(handle)) {
      return productJsonCache.get(handle);
    }

    var promise = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        if (!product || !product.images || product.images.length < 2) return '';

        var image = product.images[1];
        if (!image) return '';

        return typeof image === 'string' ? image : (image.src || '');
      })
      .catch(function () { return ''; });

    productJsonCache.set(handle, promise);
    return promise;
  }

  function createDots() {
    var dots = document.createElement('div');
    dots.className = 'zenduce-card-dots';
    dots.setAttribute('aria-hidden', 'true');
    dots.innerHTML = '<span class="zenduce-card-dot is-active"></span><span class="zenduce-card-dot"></span>';
    return dots;
  }

  function ensureSecondImage(link) {
    if (!link || link.dataset.zenduceSecondImageReady === 'true' || link.dataset.zenduceSecondImageReady === 'loading') {
      return Promise.resolve();
    }

    var card = getCard(link);
    var primaryImage = getPrimaryImage(link);
    var handle = getProductHandle(link);

    if (!card || !primaryImage || !handle) return Promise.resolve();

    link.dataset.zenduceSecondImageReady = 'loading';

    return getSecondImageSrc(handle).then(function (secondImageSrc) {
      if (!secondImageSrc) {
        link.dataset.zenduceSecondImageReady = 'false';
        return;
      }

      if (!link.querySelector('.zenduce-card-second-image')) {
        var secondImage = document.createElement('img');
        secondImage.className = 'zenduce-card-second-image';
        secondImage.src = secondImageSrc;
        secondImage.alt = primaryImage.alt || '';
        secondImage.loading = 'lazy';
        secondImage.decoding = 'async';
        secondImage.setAttribute('aria-hidden', 'true');
        link.appendChild(secondImage);
      }

      if (!link.querySelector('.zenduce-card-dots')) {
        link.appendChild(createDots());
      }

      primaryImage.classList.add('zenduce-card-primary-image');
      link.classList.add('zenduce-second-image-ready');
      card.classList.add('zenduce-card-has-second');
      link.dataset.zenduceSecondImageReady = 'true';
    });
  }

  function initLinks() {
    if (!isCollectionPage()) return;

    var links = Array.prototype.slice.call(document.querySelectorAll(productLinksSelector));
    if (!links.length) return;

    links.forEach(function (link) {
      if (link.dataset.zenduceSecondImageBound === 'true') return;
      link.dataset.zenduceSecondImageBound = 'true';

      link.addEventListener('mouseenter', function () { ensureSecondImage(link); }, { once: true });
      link.addEventListener('touchstart', function () { ensureSecondImage(link); }, { passive: true, once: true });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          ensureSecondImage(entry.target);
        });
      }, { rootMargin: '260px 0px' });

      links.forEach(function (link) { observer.observe(link); });
    } else {
      links.slice(0, 24).forEach(ensureSecondImage);
    }
  }

  var touchStartX = 0;
  var touchStartY = 0;
  var swipedLink = null;

  document.addEventListener('touchstart', function (event) {
    var link = event.target.closest && event.target.closest(productLinksSelector);
    if (!link) return;

    touchStartX = event.touches[0].clientX;
    touchStartY = event.touches[0].clientY;
    swipedLink = null;
  }, { passive: true });

  document.addEventListener('touchend', function (event) {
    var link = event.target.closest && event.target.closest(productLinksSelector);
    if (!link) return;

    var card = getCard(link);
    var changedTouch = event.changedTouches && event.changedTouches[0];
    if (!card || !changedTouch) return;

    var deltaX = changedTouch.clientX - touchStartX;
    var deltaY = changedTouch.clientY - touchStartY;

    if (Math.abs(deltaX) > 32 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
      event.preventDefault();
      swipedLink = link;

      ensureSecondImage(link).then(function () {
        if (link.dataset.zenduceSecondImageReady === 'true') {
          card.classList.toggle('zenduce-mobile-second-active');
        }
      });
    }
  }, { passive: false });

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest(productLinksSelector);
    if (!link || !swipedLink || link !== swipedLink) return;

    event.preventDefault();
    event.stopPropagation();
    swipedLink = null;
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLinks, { once: true });
  } else {
    initLinks();
  }

  window.addEventListener('pageshow', initLinks);
  document.addEventListener('shopify:section:load', initLinks);
})();
/* Zenduce collection second-image hover/swipe + dots - end */
